<template>
  <v-dialog
      v-model="showDialog"
      persistent
      width="800"
  >
    <v-card
        v-if="loading"
        class="pa-4"
    >
      <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
      ></v-progress-linear>
    </v-card>
    <v-card
        v-else-if="!confirmSms"
        class="pa-4"
    >
      <v-card-title class="justify-content-center">
        Проверка присутствия мастеров на смене
      </v-card-title>
      <table class="emp-in-work">
        <thead>
        <tr>
          <th style="width: 40%">Сотрудник</th>
<!--          <th style="width: 10%">авто в работе</th>-->
<!--          <th style="width: 10%">авто выполнено</th>-->
          <th style="width: 20%">В смене</th>
          <th style="width: 30%"></th>
        </tr>
        </thead>
        <tbody>
          <template v-for="worker in shiftWorkers" >
            <tr :key="worker.id">
              <td>
                {{worker.name}}
                <label>( {{worker.displayRole}} )</label>
              </td>
<!--              <td>-->
<!--                {{worker.salary.zp ? worker.salary.zp.cars : ''}}-->
<!--              </td>-->
<!--              <td>-->
<!--                хз-->
<!--              </td>-->
              <td>
                {{ worker.time_in_shift }}
              </td>
              <td>
                <v-btn
                    :color="workerInShift[worker.id] ? 'red' : 'green'"
                    plain
                    block
                    @click="workerinShift(worker)"
                >
                  {{ workerInShift[worker.id] ? 'убрать из смены' : 'отметить в смене' }}
                </v-btn>
              </td>
            </tr>
          </template>
        </tbody>
      </table>


      <v-select
          v-model="whoCheck"
          class="mt-4"
          label="Кто отметил:"
          item-value="id"
          item-text="name"
          :items="shiftWorkers"
      />
<!--      <template v-for="question in questions">-->
<!--        <v-radio-group-->
<!--            v-if="question.type === qtype || question.type === 'general'"-->
<!--            v-model="question.answer"-->
<!--            :key="question.id"-->
<!--            row-->
<!--        >-->
<!--          <template v-slot:label>-->
<!--            <div>{{ question.question }}</div>-->
<!--          </template>-->
<!--          <v-radio-->
<!--              :value="true"-->
<!--              label="Да"-->
<!--          ></v-radio>-->
<!--          <v-radio-->
<!--              :value="false"-->
<!--              label="Нет"-->
<!--          ></v-radio>-->
<!--        </v-radio-group>-->
<!--      </template>-->
      <v-card-actions>
        {{ workerInShiftCount }} из {{ shiftWorkers ? shiftWorkers.length : '0'}} в смене
        <v-btn
            @click="getSmsCode"
            class="ml-auto"
            :disabled="noAllChecked"
        >
          Далее
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
        v-else
        class="pa-4"
    >
      <v-card-title>
        <v-text-field
            v-model="smsCode"
            v-mask="'#####'"
            type="number"
            label="Код из СМС"
            name="smsCode"
            prepend-icon="mdi-lock"
            required
            outlined
            class="pt-6 pb-0"
            @keyup.enter="smsSubmit"
        />
        <v-alert
            v-if="errorAlert && alertTimerCount > 0"
            border="top"
            color="red lighten-2"
            dark
        >
          {{ errorAlert }}
        </v-alert>
      </v-card-title>

      <v-card-actions>
        <v-btn
            @click="confirmSms=false"
            class="mr-auto"
        >
          отмена
        </v-btn>
        <v-btn
            @click="checkSmsCode"
            class="ml-auto"
            :disabled="!smsCode || smsCode.length<5"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "@/plugins/axios-common";

export default {
  name: 'workersAtPlace',
  props: ['showDialog'],

  data() {
    return {
      alertTimerCount: null,
      errorAlert: null,
      smsCode: null,
      confirmSms: false,
      whoCheck: null,
      questions: null,
      loading: false,
      workerInShift: {}
    }
  },
  computed: {
    ...mapGetters('shift', [
      "shiftInfo",
    ]),
    shiftWorkers () {
      return this.shiftInfo.workers || null
    },
    noAllChecked () {
      return !this.whoCheck
    },
    workerInShiftCount () {
      let count = 0
      if(this.shiftInfo && this.shiftInfo.workers){
        this.shiftInfo.workers.forEach((worker) => {
          if(this.workerInShift[worker.id]){
            count++
          }
        })
      }
      return count
    }
  },
  watch: {
    showDialog (newVal) {
      if (newVal) {
        if (!this.shiftInfo.shift_id) {
          this.close()
          return
        }
        if (!this.shiftWorkers) {
          this.loading = true
          this.$store.dispatch("shift/fetchShiftInfo").then(()=>{
            this.loading = false
          })
        } else {
          this.loading = false
        }
      }
    },
    alertTimerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.alertTimerCount--;
          }, 1000);
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  methods: {
    workerinShift (worker) {
      if (!this.workerInShift[worker.id]) {
        this.workerInShift[worker.id] = true
      } else {
        this.workerInShift[worker.id] = false
      }
      this.workerInShift = JSON.parse(JSON.stringify(this.workerInShift))
    },
    accept () {
      const sendData = {
        order_id: this.orderId,
        code: this.smsCode,
        type: this.codeType,
      }
      axios({
        method: 'post',
        url: '/api/cash/order/check-otp',
        data: sendData
      }).then((resp) => {
        if (resp) {
          this.dialog = false
          window.removeEventListener('keyup', this.keyCheck)
          this.resolve()
        }
      }).catch((error) => {
        this.alertTimerCount = 60
        if ( error.response ) {
          this.errorAlert = error.response.data
        } else {
          this.errorAlert = error
        }
        console.log('error', error)
      })
    },
    close() {
      this.$emit('close')
    },
    getSmsCode() {
      const EmployeePresenceList = []
      this.shiftWorkers.forEach(worker => {
        EmployeePresenceList.push({
          id: worker.id,
          onShift: !!this.workerInShift[worker.id]
        })
      })
      this.$store.dispatch('shift/getSubmitCheckEmployeePresenceSmsCode',
          {
            shift_id: this.shiftInfo.shift_id,
            employee_presence: EmployeePresenceList,
            workerCheck: this.whoCheck
          }).then(()=>{
        this.confirmSms = true
      })
    },
    checkSmsCode() {
      this.$store.dispatch('shift/checkSubmitCheckEmployeePresenceSmsCode',
          {
            shift_id: this.shiftInfo.shift_id,
            code: this.smsCode
          }).then(()=>{
        this.$store.dispatch("sendNotification", {
          quote: "Успешно отправлено",
          type: "success"
        })
        this.close()
      }).catch((error) => {
        this.alertTimerCount = 60
        if ( error.response ) {
          this.errorAlert = error.response.data
        } else {
          this.errorAlert = error
        }
        console.log('error', error)
      })
    },
  }
}
</script>

<style scoped>
.emp-in-work {
  border: 1px black solid;
}
.emp-in-work th,td {
  border: 1px black solid;
  margin: 8px;
  padding: 4px;
}
.emp-in-work th {
  background-color: #9dcaff;
}
.close {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}
</style>
